export const OfferStatus = {
    PENDING: 'pending',
    ACTIVE: 'active',
    EXPIRED: 'expired',
    SCHEDULED: 'scheduled',
};

export const discountTypeStatus = {
    PERCENTAGE:'percentage',
    FIXED: 'fixed'
}